












































































import { MacAddressRegex } from '@/constants/device-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    hasGatewayConnectionFailure: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isAttemptingConnection: false,
      hasSuccessfulConnection: false,
      hasFailedConnection: false,
      hasAttemptedConnection: false,
      gatewayId: null,
      gatewayIdIsValid: false,
      gatewayIdRules: [
        v => !!v || 'Please enter your gateway ID',
        v =>
          MacAddressRegex.test(v) ||
          'Please double check your gateway ID. A valid gateway has 6 pairs of characters separated by colons. For example: 01:23:45:67:89:AB',
      ],
    }
  },

  computed: {
    connectButtonIsDisabled() {
      return !this.gatewayIdIsValid || this.isAttemptingConnection || this.hasSuccessfulConnection
    },
    connectButton() {
      const isGreyedOut = !this.gatewayIdIsValid || this.isAttemptingConnection
      const isConnected = this.hasSuccessfulConnection
      return {
        color: isConnected ? 'green' : 'device-management-blue',
        isDepressed: isConnected,
        isConnected: isConnected,
        icon: isConnected ? 'mdi-check-circle-outline' : 'mdi-access-point',
        text: isConnected ? 'Connected' : 'Connect',
        isDisabled: isGreyedOut,
        action: isConnected ? () => {} : this.connectToGateway,
        ripple: !isConnected && !isGreyedOut,
      }
    },
    connectionAttemptMessages() {
      return [
        {
          text: 'Gateway successfully connected',
          icon: 'mdi-check-circle-outline',
          color: 'green',
          show: this.hasSuccessfulConnection && !this.hasGatewayConnectionFailure,
        },
        {
          text: 'Failed to connect to gateway. Please confirm your gateway ID and try again',
          icon: 'mdi-close-circle-outline',
          color: 'red',
          show: this.hasAttemptedConnection && !this.hasSuccessfulConnection,
        },
      ]
    },
  },

  methods: {
    async connectToGateway() {
      console.info('this function will handle the initial gateway connection')
      //01:02:03:04:05:AB
      try {
        this.hasAttemptedConnection = false
        this.isAttemptingConnection = true
        setTimeout(() => {
          this.isAttemptingConnection = false
          //this.hasSuccessfulConnection = false;
          this.hasSuccessfulConnection = true
          this.$emit('setGatewayId', this.gatewayId)
          this.$emit('stageIsValid', {
            stageIndex: this.stageIndex,
            isValid: true,
          })
          this.hasAttemptedConnection = true
        }, 2000)
      } catch (err) {
        console.log(err)
      } finally {
        //this.hasAttemptedConnection = true;
      }
    },
  },
}
